import React, { useState } from 'react';
import { toast, Toaster } from 'react-hot-toast';  // Sử dụng toast từ react-hot-toast
import BASE_URL from '../../configs/api';
import axios from 'axios';
const ChangePassword = ({ isOpen, onClose }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isPasswordChanged, setIsPasswordChanged] = useState(false); 

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); 

    if (!currentPassword || !newPassword || !confirmPassword) {
      setLoading(false); 
      toast.error('Vui lòng điền đầy đủ các trường.'); 
      return;
    }
    if (newPassword !== confirmPassword) {
      setLoading(false); 
      toast.error('Mật khẩu mới và xác nhận mật khẩu không khớp.'); 
      return;
    }

    const token = localStorage.getItem('accessToken'); 

    if (!token) {
      setLoading(false); 
      toast.error('Phiên làm việc đã hết hạn. Vui lòng đăng nhập lại.'); 
      return;
    }

    try {
      const response = await axios.post(
        `${BASE_URL}/api/auth/change-password/`,
        {
          old_password: currentPassword,
          new_password: newPassword,
          confirm_new_password: confirmPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
  
      // handleClose();
      // setIsPasswordChanged(true);
      toast.success('Đổi mật khẩu thành công!');
  
    } catch (error) {
      const errorMsg = error.response?.data?.message || 'Có lỗi xảy ra. Vui lòng thử lại.';
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
    setError('');
    onClose();
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 transition-opacity duration-300 px-4"
      onClick={handleOverlayClick}
    >
      <div className="bg-[#2a314e] rounded-lg shadow-xl p-6 md:p-8 w-full max-w-md transform transition-all duration-300 scale-100 opacity-100">
        <div className="relative mb-6 text-center">
          <h3 className="text-xl font-semibold text-white">Đổi mật khẩu</h3>
          <button
            onClick={handleClose}
            className="absolute top-0 right-0 text-gray-400 hover:text-white text-2xl leading-none focus:outline-none"
            aria-label="Đóng"
          >
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          {error && <p className="text-red-400 text-sm mb-4 text-center">{error}</p>}

          <div className="mb-5">
            <label className="block text-sm font-medium text-gray-300 mb-2" htmlFor="currentPassword">
              Mật khẩu cũ
            </label>
            <input
              type="password"
              id="currentPassword"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
              className="block w-full bg-[#2a314e] border-[1px] border-white/20 rounded-md py-2.5 px-3 text-white shadow-sm focus:outline-none focus:ring-1 focus:border-white sm:text-sm"
            />
          </div>

          <div className="mb-5">
            <label className="block text-sm font-medium text-gray-300 mb-2" htmlFor="newPassword">
              Mật khẩu mới
            </label>
            <input
              type="password"
              id="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              className="block w-full bg-[#2a314e] border-[1px] border-white/20 rounded-md py-2.5 px-3 text-white shadow-sm focus:outline-none focus:ring-1 focus:border-white sm:text-sm"
            />
          </div>

          <div className="mb-8">
            <label className="block text-sm font-medium text-gray-300 mb-2" htmlFor="confirmPassword">
              Xác nhận mật khẩu mới
            </label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className="block w-full bg-[#2a314e] border-[1px] border-white/20 rounded-md py-2.5 px-3 text-white shadow-sm focus:outline-none focus:ring-1 focus:border-white sm:text-sm"
            />
          </div>

          <div className="flex justify-center gap-4">
            <button
              type="submit"
              className="bg-[#FFD875] hover:bg-[#fcc74e] text-black font-medium py-2 px-5 rounded-md transition duration-150 ease-in-out text-sm"
              disabled={loading} // Disabled khi đang loading
            >
              {loading ? 'Đang xử lý...' : 'Đổi mật khẩu'}
            </button>
            <button
              type="button"
              onClick={handleClose}
              className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-2 px-5 rounded-md transition duration-150 ease-in-out text-sm"
            >
              Đóng
            </button>
          </div>
        </form>
      </div>

      {/* Thêm Toaster để hiển thị các thông báo */}
      <Toaster />
    </div>
  );
};

export default ChangePassword;
